import { playerActions } from "./playerSlice";
import {
  FILE_UPLOAD_PRIVATE,
  GET_INHOUSE,
  INHOUSE_CHANNEL,
  INHOUSE_CHANNEL_LIST,
  INHOUSE_EPISODE,
  PODCAST,
  PODCAST_CHANNEL,
} from "./constants";
import CommonAPI from "../lib/common";
import CommonLocal from "../lib/commonLocal";
import { toast } from "react-hot-toast";
import { publicActions } from "./publicSlice";
import AWSapi from "../lib/awsapi";
import API from "../lib/apiMultipart";

export const togglePlaying = (props) => {
  return async (dispatch) => {
    dispatch(playerActions.isPlaying(props));
  };
};
export const setAudioPlayer = (playerData) => {
  return async (dispatch) => {
    dispatch(playerActions.setAudioPlayer(playerData));
  };
};

export const getPodcast = () => {
  return async (dispatch) => {
    try {
      const response = await CommonLocal(PODCAST);
      dispatch(playerActions.getPodcast({ response: response }));
      return response;
    } catch (error) {
      // console.log(error);
      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};
export const getInHouse = () => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(GET_INHOUSE);
      //console.log("getInHouse", response);
      dispatch(playerActions.getInHouse({ response: response }));
      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));

      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};

export const addInHouseChannel = (values, setSelectedAction, thumbnail) => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonAPI(
        FILE_UPLOAD_PRIVATE,
        {
          file_name: thumbnail?.name,
          file_type: thumbnail?.type,
          file_category: "content",
          public: true,
        },
        "PUT"
      );
      // console.log("response", response);
      const awsValues = {
        acl: response?.fields?.acl,
        "Content-Type": response?.fields["Content-Type"],

        key: response?.fields.key,

        "x-amz-algorithm": response?.fields["x-amz-algorithm"],

        "x-amz-credential": response?.fields["x-amz-credential"],
        "x-amz-date": response?.fields["x-amz-date"],
        policy: response?.fields?.policy,
        "x-amz-signature": response?.fields["x-amz-signature"],
        file: thumbnail,
      };
      // console.log("awsValues", awsValues);
      // const responseAWS = await API.post(awsValues);
      const responseAWS = await AWSapi("/", awsValues, "POST");
      //   const requestOptions = {
      //     method: 'POST',
      //     headers: { 'Content-Type': 'multipart/form-data' },
      //     body: awsValues
      // };
      // await fetch('https://ccubicle.s3.amazonaws.com', requestOptions)
      //     .then(response => response.json())
      //     .then(data => console.log(data));

      // console.log("responseAWS", responseAWS);
      // const responseChannel = await CommonLocal(INHOUSE_CHANNEL, values, "POST");
      toast.success("Channel added successfully..");
      setSelectedAction("list");
      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};

export const getInHouseChannels = () => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(INHOUSE_CHANNEL);
      dispatch(playerActions.getInHouseChannels({ response: response }));
      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));

      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};

export const editChannel = (values, item, setShow) => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(
        INHOUSE_CHANNEL + item.uuid,
        values,
        "PATCH"
      );
      toast.success("Channel updated successfully");
      setShow(false);
      // console.log(response);
      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));
    }
  };
};
export const getSingleChannel = (selectedItem, setSelectedItem) => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(INHOUSE_CHANNEL + selectedItem?.uuid);
      // console.log("response", response);
      setSelectedItem(response);
      dispatch(playerActions.getSingleChannel({ response: response }));
      dispatch(publicActions.isLoading(false));
      // console.log("response", response);
      setSelectedItem(response);
      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));

      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};

export const uploadEpisode = (values, setSelectedAction, media, thumbnail) => {
  // console.log(media);
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      // const thumbResponse = await CommonAPI(
      //   FILE_UPLOAD_PRIVATE,
      //   {
      //     file_name: thumbnail?.name,
      //     file_type: thumbnail?.type,
      //     file_category: "content",
      //     public: true,
      //   },
      //   "PUT"
      // );

      // const mediaResponse = await CommonAPI(
      //   FILE_UPLOAD_PRIVATE,
      //   {
      //     file_name: media?.name,
      //     file_type: media?.type,
      //     file_category: "content",
      //     public: true,
      //   },
      //   "PUT"
      // );

      // const awsValuesThumbnail = {
      //   acl: thumbResponse?.fields?.acl,
      //   "Content-Type": thumbResponse?.fields["Content-Type"],

      //   key: thumbResponse?.fields.key,

      //   "x-amz-algorithm": thumbResponse?.fields["x-amz-algorithm"],

      //   "x-amz-credential": thumbResponse?.fields["x-amz-credential"],
      //   "x-amz-date": thumbResponse?.fields["x-amz-date"],
      //   policy: thumbResponse?.fields?.policy,
      //   "x-amz-signature": thumbResponse?.fields["x-amz-signature"],
      //   file: thumbnail,
      // };

      // const responseAWSThumbnail = await AWSapi(
      //   "/",
      //   awsValuesThumbnail,
      //   "POST"
      // );

      // const awsValuesMedia = {
      //   acl: mediaResponse?.fields?.acl,
      //   "Content-Type": mediaResponse?.fields["Content-Type"],

      //   key: mediaResponse?.fields.key,

      //   "x-amz-algorithm": mediaResponse?.fields["x-amz-algorithm"],

      //   "x-amz-credential": mediaResponse?.fields["x-amz-credential"],
      //   "x-amz-date": mediaResponse?.fields["x-amz-date"],
      //   policy: mediaResponse?.fields?.policy,
      //   "x-amz-signature": mediaResponse?.fields["x-amz-signature"],
      //   file: media,
      // };

      // const responseAWSMedia = await AWSapi("/", awsValuesMedia, "POST");

      // const response = "";
      const response = await CommonLocal(INHOUSE_EPISODE, values, "POST");
      toast.success("Episode added successfully..");
      setSelectedAction("list");
      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};

export const getClientEpisodes = (selectedItem) => {
  return async (dispatch) => {
    try {
      dispatch(publicActions.isLoading(true));
      const response = await CommonLocal(INHOUSE_EPISODE);
      dispatch(playerActions.getClientEpisodes({ response: response }));

      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));

      //   if (error.response && error.response.data.message !== "") {
      //     dispatch(todoActions.alert(error.response.data.message));
      //   } else {
      //     dispatch(todoActions.alert("Something went wrong. Please try again."));
      //   }
    }
  };
};

export const editEpisode = (values, selectedItem, handleClose) => {
  return async (dispatch) => {
    try {
      dispatch(publicActions.isLoading(true));
      const response = await CommonLocal(
        INHOUSE_EPISODE + selectedItem.uuid,
        values,
        "PUT"
      );
      toast.success("Episode updated successfully");
      handleClose();
      // console.log(response);
      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));
    }
  };
};

export const addEpisodeToChannel = (values, setSelectedAction) => {
  return async (dispatch) => {
    dispatch(publicActions.isLoading(true));
    try {
      const response = await CommonLocal(INHOUSE_CHANNEL_LIST, values, "POST");
      // dispatch(ticketActions.setTicket({ response: response }));
      toast.success("Episode added successfully..");
      // setSelectedAction("list");
      dispatch(publicActions.isLoading(false));
      return response;
    } catch (error) {
      // console.log(error);
      dispatch(publicActions.isLoading(false));

      // if (error.response && error.response.data.message !== "") {
      //   dispatch(ticketActions.alert(error.response.data.message));
      // } else {
      //   dispatch(ticketActions.alert("Something went wrong. Please try again."));
      // }
    }
  };
};
